import getNestedProp from '../getNestedProp'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

const cleanObject = (rules, value) => {
  return rules.reduce((prev, rule) => {
    const newValue = prev;
    const propValue = getNestedProp(newValue, rule.key);

    if (propValue === 'undefined' || propValue === '' || propValue === undefined) {
      delete newValue[rule.keyToRemove];
    }

    return newValue;
  }, Object.assign({}, value));
};

export default cleanObject;